export default __webpack_public_path__ + "static/media/magic-wand.cd05f3af.svg";